import axiosHttp from "./interceptor.service";

const createTask = (data) => {
    return axiosHttp.post("/feedback/createTask", data);
};

const getTask = ({ sort, page, limit, search, departmentId, inchargeId, isTask, urgencyStatus, startDate, endDate } = {}) => {
    return axiosHttp.get("/feedback/getTask", {
        params: { sort, page, limit, search, departmentId, inchargeId, isTask, urgencyStatus, startDate, endDate },
    });
};

const getTaskById = (id) => {
    return axiosHttp.get(`/feedback/getTaskById/${id}`);
};

const updateTask = (id, data) => {
    return axiosHttp.put(`/feedback/updateTask/${id}`, data);
};

const deleteTask = (id) => {
    return axiosHttp.delete(`/feedback/deleteTask/${id}`);
};

const getTaskHistory = (taskId) => {
    return axiosHttp.get("/feedback/getTaskHistory", {
        params: { taskId }
    });
};

export { createTask, getTask, getTaskById, updateTask, deleteTask, getTaskHistory };
